import LandingPreHow1 from "components/pages/landing/pre/LandingPreHow1";
import LandingPreHow2 from "components/pages/landing/pre/LandingPreHow2";
import LandingPreHow3 from "components/pages/landing/pre/LandingPreHow3";
import styles from "css/pages/landing/pre/LandingPreHow.module.css";
import { useState } from "react";

export default function LandingPreHow(): JSX.Element {
  const [page, setPage] = useState(0);

  // TODO: make all them fixed heights so transitions are smoother
  return (
    <div className={styles.containerOuter}>
      <LandingPreHow1 isHidden={page !== 0} onNext={() => setPage(1)} />
      <LandingPreHow2
        isHidden={page !== 1}
        onNext={() => setPage(2)}
        onPrev={() => setPage(0)}
      />
      <LandingPreHow3 isHidden={page !== 2} onPrev={() => setPage(1)} />
    </div>
  );
}
